import script from "./RoadPriceForm.vue?vue&type=script&setup=true&lang=js"
export * from "./RoadPriceForm.vue?vue&type=script&setup=true&lang=js"

import "./RoadPriceForm.vue?vue&type=style&index=0&id=281d020a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-281d020a"]])

export default __exports__